<template>
<v-card style="width: 100%;">
    <v-expansion-panel v-model="currSection">
      <v-expansion-panel-content v-for="(section, n) in sections" :key="n">
        <h3 slot="header" title>
        {{section.title}}
        </h3>
        <v-card light>
          <v-card-text>
              <ul>
                  <li v-for="thing in section.descriptions" :key="thing">{{ thing }}</li>
              </ul>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-card>
</template>
<script>
export default {
  name: 'updates',
  data() {
    return {
      currSection: 0,
      sections: [
        {
          title: '17. Mai 2019',
          descriptions: [
            'Tourdetails können aus dem Livetracking heraus geöffnet werden.',
            'Auftragsdetails innerhalb der Tourdetails werden korrekt dargestellt',
            'Gelöscht / Erledigt in den Details nur wenn entsprechendes zutrifft',
            'Löschgrund wird angeführt'
          ]
        },
        {
          title: '16. Mai 2019',
          descriptions: [
            'Platzhalter im Dashboard durch Aufträge und Gefahrene Strecke (noch ohne Daten, komme noch nicht von den iPads) ersetzt',
            'Sortierung des Menüs angepasst, Livetracking steht nun an zweiter Stelle',
            'Im Livetracking gibt es eine Übersicht der Touren, der Haken füllt sich bei abgeschlossener Tour grün (Daten kommen noch nicht von den iPads)',
            'Eine Suche mittels Ladescheinnummer kann nun von überall aus in der Titelleiste gestartet werden',
            'Anpassungen im Code / Bugfixes'
          ]
        },
        {
          title: '14. Mai 2019',
          descriptions: [
            'Karte in den Tourdetails komplett neu geschrieben',
            'Route kann zwischen gefahrenen und errechneten Touren umgeschaltet werden (noch fehlerhaft)',
            'Erweitertes Fehlerhandling'
          ]
        },
        {
          title: '30. April 2019',
          descriptions: [
            'Im Livetracking werden die Fahrer mittels LKW Marker dargestellt',
            'Im Livetracking werden LKW nicht mehr gleichzeitig an zwei verschiedenen Standorten angezeigt',
            'Auftragsübersicht enthält wieder Daten',
            'Detailansicht der Tour hinzugefügt',
            ' - Kunden werden mit roten Markern auf der Karte dargestellt',
            ' - Fahrer werden mit einem LKW auf der Karte dargestellt',
            'Kleinere Anpassungen im Zusammenspiel mit dem Backend',
            'Einige Fehler und Warnungen reduziert'
          ]
        },
        {
          title: '12. April 2019',
          descriptions: [
            'Kundenstandorte werden ab sofort aus der eigenen Datenbank abgerufen, statt von Google Maps',
            'E-Mail, Telefonnummer und Mobiltelefonnummer der Kunden werden angezeigt',
            'Bei einem Klick auf die E-Mail öffnet sich die entsprechende Anwendung zur Erfassung von E-Mails',
            'Updates aus dem Dashboard in eine eigene Kategorie zur besseren Archivierbarkeit ausgelagert',
            'Kontaktdaten im Dashboard hinterlegt',
            'Benutzer können angelegt werden',
            'Benutzer können gelöscht werden',
            'Berücksichtung von Adminrechten im gesamten Frontend',
            'Alle Seiten haben eine Titelzeile zur besseren orientieren auf Mobilgeräten bekommen'
          ]
        },
        {
          title: '08. April 2019',
          descriptions: [
            'Zeitstempel bei den Geräten lesbarer gestaltet',
            'Aufträge werden nun, abhängig vom Status, grün oder rot dargestellt',
            'Aufträge anklickbar',
            'Auftragdetails werden modal dargestellt',
            'Updates im Dashboard übersichtlicher dargestellt',
            'Dashboard um Statusinformationen erweitert',
            'Dashboard nun auch für kleinere Displays (mobile) geeignet',
            'Benutzername, E-Mail und Logout Button im Menü eingebaut'
          ]
        }
      ]
    };
  }
};
</script>
